import React from "react";
import "./ProductPortfolioCard.css";

export default function ProductPortfolioCard({ product, theme }) {
  function openUrlInNewTab(url) {
    if (url) {
      var win = window.open(url, "_blank");
      win.focus();
    }
  }

  // Tag color mapping based on tag type
  const getTagColor = (tag) => {
    const tagLower = tag.toLowerCase();
    if (tagLower.includes("product case")) return "#FF6B35"; // Orange
    if (tagLower.includes("healthtech")) return "#4ECDC4"; // Light blue
    if (tagLower.includes("fintech")) return "#9B59B6"; // Purple
    if (tagLower.includes("proptech")) return "#9B59B6"; // Purple
    if (tagLower.includes("insurtech")) return "#4ECDC4"; // Light blue
    if (tagLower.includes("ai")) return "#95A5A6"; // Grey
    if (tagLower.includes("technical")) return "#FF6B35"; // Orange
    if (tagLower.includes("gold")) return "#F1C40F"; // Yellow
    if (tagLower.includes("bronze")) return "#D35400"; // Brown
    if (tagLower.includes("startup")) return "#FF6B35"; // Orange
    if (tagLower.includes("investment")) return "#FF6B35"; // Orange
    if (tagLower.includes("user retention")) return "#4ECDC4"; // Light blue
    if (tagLower.includes("user experience")) return "#FF6B35"; // Orange
    if (tagLower.includes("sustainable")) return "#4ECDC4"; // Light blue
    if (tagLower.includes("export") || tagLower.includes("import"))
      return "#9B59B6"; // Purple
    if (tagLower.includes("global")) return "#9B59B6"; // Purple
    return "#95A5A6"; // Default grey
  };

  return (
    <div
      className="product-card-grid"
      style={{ backgroundColor: theme.highlight }}
      onClick={() => product.link && openUrlInNewTab(product.link)}
    >
      <div className="product-image-container-grid">
        <img
          src={require(`../../assests/images/${product.image}`)}
          alt={product.title}
          className="product-image-grid"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      </div>
      <div className="product-content-grid">
        <div className="product-header-grid">
          <span className="product-icon">📄</span>
          <h3 className="product-title-grid" style={{ color: theme.text }}>
            {product.title}
          </h3>
        </div>

        {/* Tags */}
        <div className="product-tags-container">
          {product.userSegments &&
            product.userSegments.map((segment, index) => (
              <span
                key={index}
                className="product-tag"
                style={{
                  backgroundColor: getTagColor(segment) + "20",
                  color: getTagColor(segment),
                  borderColor: getTagColor(segment) + "40",
                }}
              >
                {segment}
              </span>
            ))}
          {product.tags &&
            product.tags.map((tag, index) => (
              <span
                key={`tag-${index}`}
                className="product-tag"
                style={{
                  backgroundColor: getTagColor(tag) + "20",
                  color: getTagColor(tag),
                  borderColor: getTagColor(tag) + "40",
                }}
              >
                {tag}
              </span>
            ))}
        </div>

        <p
          className="product-description-grid"
          style={{ color: theme.secondaryText }}
        >
          {product.description}
        </p>

        {product.company && (
          <p
            className="product-company-grid"
            style={{ color: theme.secondaryText }}
          >
            {product.company}
          </p>
        )}
      </div>
    </div>
  );
}
